// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.smart-emoji-picker {
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Emoji picker section */
.emoji-picker-section {
  position: relative;
}

/* Override emoji-picker-react styles for selected emojis */
.smart-emoji-picker .EmojiPickerReact {
  border: none;
  box-shadow: none;
  max-height: 400px;
  overflow: hidden;
}

/* Custom styling for reactions that user has already selected */
.smart-emoji-picker .EmojiPickerReact button[data-unified] {
  position: relative;
}

/* Highlight emojis that the user has already reacted with */
.smart-emoji-picker .EmojiPickerReact button.user-selected-emoji {
  background-color: #e3f2fd !important;
  border: 2px solid #2196f3 !important;
  border-radius: 6px !important;
  transform: scale(0.95);
  box-shadow: 0 1px 4px rgba(33, 150, 243, 0.3) !important;
}

.smart-emoji-picker .EmojiPickerReact button.user-selected-emoji:hover {
  background-color: #ffcdd2 !important;
  border-color: #f44336 !important;
  box-shadow: 0 1px 4px rgba(244, 67, 54, 0.3) !important;
}

/* Dark mode support */
.smart-emoji-picker.dark-theme {
  background: #2d2d2d;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/Messages/SmartEmojiPicker.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;AACpB;;AAEA,2DAA2D;AAC3D;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;AACpB;;AAEA,4DAA4D;AAC5D;EACE,oCAAoC;EACpC,oCAAoC;EACpC,6BAA6B;EAC7B,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".smart-emoji-picker {\n  display: flex;\n  flex-direction: column;\n  background: white;\n  border-radius: 30px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* Emoji picker section */\n.emoji-picker-section {\n  position: relative;\n}\n\n/* Override emoji-picker-react styles for selected emojis */\n.smart-emoji-picker .EmojiPickerReact {\n  border: none;\n  box-shadow: none;\n  max-height: 400px;\n  overflow: hidden;\n}\n\n/* Custom styling for reactions that user has already selected */\n.smart-emoji-picker .EmojiPickerReact button[data-unified] {\n  position: relative;\n}\n\n/* Highlight emojis that the user has already reacted with */\n.smart-emoji-picker .EmojiPickerReact button.user-selected-emoji {\n  background-color: #e3f2fd !important;\n  border: 2px solid #2196f3 !important;\n  border-radius: 6px !important;\n  transform: scale(0.95);\n  box-shadow: 0 1px 4px rgba(33, 150, 243, 0.3) !important;\n}\n\n.smart-emoji-picker .EmojiPickerReact button.user-selected-emoji:hover {\n  background-color: #ffcdd2 !important;\n  border-color: #f44336 !important;\n  box-shadow: 0 1px 4px rgba(244, 67, 54, 0.3) !important;\n}\n\n/* Dark mode support */\n.smart-emoji-picker.dark-theme {\n  background: #2d2d2d;\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
